import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/assets/menu/categories/52-moto-casual-gorros.svg")